import { Component, input, output } from '@angular/core';
import { ActionItem } from '@gs-2.0/core';

/**
 * A component that displays quick action cards for fund management.
 * Actions are provided via input and vary based on fund type.
 * Based on Figma design.
 * Figma URL: https://www.figma.com/design/W3VBXvQM2bo98mSNlDSzhi/GivingSpace-Reimagining?node-id=1058-36046
 *
 * @example
 * ```html
 * <app-fund-actions
 *   [actions]="fundActions()"
 *   (actionClicked)="handleAction($event)">
 * </app-fund-actions>
 * ```
 */
@Component({
  selector: 'app-fund-actions',
  templateUrl: './fund-actions.component.html',
  styleUrls: ['./fund-actions.component.scss'],
  standalone: false,
})
export class FundActionsComponent {
  /**
   * Array of action configurations to display
   * Actions vary based on fund type (DAF, CHARITY, PROJECT)
   */
  actions = input<ActionItem[]>([]);

  /**
   * Emits when an action card is clicked
   * Emits the action type: 'contribute' | 'grant' | 'distribute' | 'activity' | 'transfer' | 'currencyConversion'
   */
  actionClicked = output<string>();

  /**
   * Handles action card clicks
   * @param action The action type that was clicked
   */
  onActionClick(action: string): void {
    this.actionClicked.emit(action);
  }
}
